import { type CacheInfo } from './types';

export const normalizeCacheHit = (cacheInfo: CacheInfo | undefined): boolean | null => {
	if (!cacheInfo) {
		return null;
	}
	return cacheInfo.cache_hit ?? null;
};
